export default theme => ({
  list: {},
  addNewBtn: {
    color: theme.palette.primary.main
  }
});
